import { defineComponent } from "vue";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "color-selector",
  props: {
    variants: { default: void 0 },
    value: { default: void 0 },
    noLink: { type: Boolean },
    isAccessible: { type: Boolean, default: true },
    large: { type: Boolean },
    medium: { type: Boolean }
  },
  emits: ["select-variant", "input"],
  setup(__props) {
    const style = (color) => {
      const styles = {};
      if (color == null ? void 0 : color.code) {
        styles.background = color.code;
      }
      return styles;
    };
    return { __sfc: true, style, LinkButton };
  }
});
export {
  _sfc_main as default
};
